import { instance } from 'utils/axios.utils';
import { UploadObjectData } from 'utils/interface.utils';

export const uploadObject = async (
  targetId: string,
  type: 'image' | 'video',
  file: File,
  replacesObjectId?: string,
): Promise<UploadObjectData> => {
  const formData = new FormData();
  formData.append('target_id', targetId);
  formData.append('type', type);
  // The server removes the replaced object only after the new one is created.
  if (replacesObjectId) formData.append('replaces_object_id', replacesObjectId);
  formData.append('file', file);

  const response = await instance().post('object/upload_object', formData);

  return response.data.data;
};

export const deleteObject = async (objectId: string): Promise<void> => {
  await instance().post('object/delete_object', { object_id: objectId });
};

const object = { uploadObject, deleteObject };

export default object;
